import * as React from 'react';
import { MessageCard } from '../../designSystem/Message';
import { useParams } from 'react-router-dom';
import { logout } from '../../api/authClientApi';
import { useEffect } from 'react';
import { ProtectedPageWrapper } from '../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { CommandResult } from '../../amorg-common';
import { errorCodes } from '../../amorg-common';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { confirmNewEmail } from '../../api/userClientApi';
import { PageHeader } from '../../designSystem/PageHeader';

export default function ConfirmNewEmailPage(): JSX.Element {

    const [result, setResult] = React.useState<CommandResult | undefined>(undefined);
    const params = useParams<{ siteId: string, userId: string, requestId: string }>();

    useEffect(() => {
        const getData = async () => {
            const result = await confirmNewEmail(params.siteId, params.userId, params.requestId);
            setResult(result);
            if (result.isSuccess) {
                await logout();
            }
        };
        getData();
    }, []);

    return (

        <ProtectedPageWrapper requiredPermissions={['EditUser']}>

            <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                    <PageHeader headerText="Bekræft ny e-mail addresse" headerStyle='primary-black' />
                
                        {result &&
                            <Result value={result as CommandResult} />
                        }
                    </>
                }
            />

        </ProtectedPageWrapper>
    );
}

type ResultProps = { value: CommandResult }
function Result({ value: result }: ResultProps): JSX.Element {
    const messageType = result.isSuccess ? 'success' : 'error';
    return (
        <>
            {result.isSuccess
                ? <MessageCard variant={messageType}>Din e-mail addresse er ændret. Log ind for at tage den i brug.</MessageCard>
                : getErrorMessage(result.errorMessage)
            }
        </>
    );

    function getErrorMessage(error: errorCodes) {
        switch (error) {
            case 'invalid_site':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmNewUserEmail_invalid_requestId':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmNewUserEmail_invalid_userId':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmNewUserEmail_no_requests_exist':
                return <MessageCard variant={'error'}>Linket er ikke længere gyldigt. Du kan oprette en ny ændring fra profil menuen.</MessageCard>
            case 'confirmNewUserEmail_email_in_use':
                return <MessageCard variant={'error'}>Den valgte e-mail er allerede i brug.  Du kan oprette en ny ændring fra profil menuen.</MessageCard>
            default:
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
        }
    }
}